import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { dismissNotification } from '../actions'
import * as constants from '../constants';
import moment from 'moment';

import { getAndReplaceBooking, acceptBooking, rejectBooking } from '../../bookings/actions';

class NotificationUrgentComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.dismiss = this.dismiss.bind(this);
    this.loadAdditionalData = this.loadAdditionalData.bind(this);
    this.navigateToAccountSettings = this.navigateToAccountSettings.bind(this);
  }

  componentDidMount() {
    let { notification, booking } = this.props;
    if (notification && notification.booking && (!booking || !booking.userId)) {
      setTimeout(this.loadAdditionalData, 240);
    }
  }

  loadAdditionalData() {
    let { notification, booking, dispatch } = this.props;
    if (notification && notification.booking && (!booking || !booking.userId)) {
      dispatch(getAndReplaceBooking(notification.booking));
    }
  }

  dismiss() {
    let { notification, dispatch } = this.props;
    dispatch(dismissNotification(notification));
  }

  acceptBookingRequest() {
    let { booking, notification, dispatch } = this.props;
    dispatch(acceptBooking(booking, notification));
  }

  rejectBookingRequest() {
    let { booking, notification, dispatch } = this.props;
    dispatch(rejectBooking(booking, notification));
  }

  navigateToAccountSettings() {
    let { history } = this.props;
    this.dismiss();
    history.push('/dashboard/account');
  }

  renderTitle(notification, booking) {
    switch (notification.notificationType) {
      case constants.TYPE_OWNER_BOOKING_REQUEST:
        return 'Booking Request';
      case constants.TYPE_RENTER_BOOKING_APPROVED_FAILURE:
        return 'Booking Payment Failure';
      case constants.TYPE_RENTER_BOOKING_DEPOSIT_ERROR:
        return 'Booking Deposit Error';
      default:
        return null;
    }
  }

  renderNotificationActions(notificationType, booking) {
    switch (notificationType) {
      case constants.TYPE_OWNER_BOOKING_REQUEST:
        return (<div className="mt-2">
          <div className="d-inline-block mr-2 mb-2"><button className="btn btn-primary" onClick={() => this.acceptBookingRequest()} type="button">Approve</button></div>
          <div className="d-inline-block mr-2 mb-3"><button className="btn btn-secondary" onClick={() => this.rejectBookingRequest()} type="button">Deny</button></div>
          <div className="d-inline-block mr-2 link-block"><Link to={`/dashboard/bookings/${booking._id}`}>View Booking Request</Link></div>
          <div className="d-inline-block mr-2 link-block"><Link to={`/profile/${booking.userId._id}`}>
            View {booking.userId.firstName} {booking.userId.lastName.slice(0, 1)}.'s Profile</Link></div>
        </div>);
      case constants.TYPE_RENTER_BOOKING_APPROVED_FAILURE:
        return (<div className="mt-2">
          <div className="d-inline-block mr-2 mb-2"><Link to={`/dashboard/account`} >
            <button className="btn btn-primary" type="button">Account Settings</button></Link></div>
          <div className="d-inline-block mr-2 mb-2"><Link to={`/dashboard/bookings/${booking._id}`}>
            <button className="btn btn-secondary" >Complete Booking</button></Link></div>
        </div>);
      case constants.TYPE_RENTER_BOOKING_DEPOSIT_ERROR:
        return (<div className="mt-2">
          <div><button onClick={this.navigateToAccountSettings} className="btn btn-primary" >Account Settings</button></div>
        </div>);
      default:
        return false;
    }
  }

  render() {
    let { notification, booking } = this.props;
    if (!notification || !booking || !booking.userId) {
      return (<div>Loading...</div>)
    }
    return (<div className="dashboard-notification dashboard-notification-request">
      <div className="row">
        <div className="col-lg-10 col-9 notification-text">
          <div className="">
            <strong><i className="fas fa-exclamation" /> {this.renderTitle(notification, booking)}</strong>
          </div>
          <div>
            {notification.message}
          </div>
          {!notification.dismissed && this.renderNotificationActions(notification.notificationType, booking)}
        </div>
        <div className="col-lg-2 col-3 notification-status">
          <div className="text-right">
            <span>{moment(notification.createdDate).fromNow()}</span>
          </div>
        </div>
      </div>
    </div>);

  }
}

export default withRouter(connect()(NotificationUrgentComponent));
